import type { ComponentProps } from "react";
import { Button } from "@/components/ui/button";
import { useBankIdStore } from "@/stores/bank-id/bank-id-store";
import type { BankIdState } from "@/stores/bank-id/bank-id-store.types";

export function BankIdButton({
  children,
  ...props
}: ComponentProps<typeof Button>) {
  const sessionCreated = useBankIdStore(
    (state: BankIdState) => state.sessionCreated
  );

  return (
    <Button disabled={!sessionCreated} size={"sm"} {...props}>
      {children}
    </Button>
  );
}
